// Chrome popup OAuth skip — WalletKit is not mounted, so neither the Better
// Stack JS tag (`TelemetryInitializer` lives under SdkV2Provider children)
// nor AnalyticsProvider exist on this document. Same-origin sendBeacon is
// the production signal (survives popup close and ad-blockers).

import { logger } from '@/lib/telemetry/logger';
import { POPUP_CALLBACK_SKIP_EVENT } from '@/lib/telemetry/popup-callback-skip-contract';

const ENDPOINT = '/api/telemetry-beacon';

export type PopupCallbackSkipPayload = {
  had_code: boolean;
  had_id_token: boolean;
};

export function reportPopupCallbackSkip(payload: PopupCallbackSkipPayload): void {
  logger.info(POPUP_CALLBACK_SKIP_EVENT, payload);

  if (typeof navigator === 'undefined' || typeof navigator.sendBeacon !== 'function') return;
  try {
    const blob: Blob = new Blob(
      [
        JSON.stringify({
          event: POPUP_CALLBACK_SKIP_EVENT,
          had_code: payload.had_code,
          had_id_token: payload.had_id_token,
        }),
      ],
      { type: 'application/json' },
    );
    navigator.sendBeacon(ENDPOINT, blob);
  } catch {
    // SILENT-CATCH: telemetry must never crash the page.
  }
}
